import { Avatar } from "antd";
import React from "react";
import { BiSolidEdit } from "react-icons/bi";

const ImageUpload = ({ handleImageUpload, index = 0, itemImage }) => {
  return (
    <div className="position-relative d-inline-block">
      {/* Hidden Input */}
      <input
        type="file"
        accept="image/*"
        onChange={(e) => handleImageUpload("image", e.target.files[0])}
        style={{ display: "none" }}
        id={`image-upload-${index}`}
      />

      {/* Image or Avatar */}
      <label htmlFor={`image-upload-${index}`} style={{ cursor: "pointer" }}>
        <div
          className="rounded-circle overflow-hidden shadow-sm position-relative"
          style={{
            width: "100px",
            height: "100px",
            border: "4px solid #f8f9fa",
            transition: "all 0.3s ease",
          }}
        >
          {itemImage ? (
            <img
              src={
                typeof itemImage === "object"
                  ? URL.createObjectURL(itemImage)
                  : itemImage
              }
              alt="Profile"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          ) : (
            <Avatar
              shape="circle"
              size={100}
              icon={<BiSolidEdit size={30} />}
              style={{
                backgroundColor: "#f0f0f0",
                color: "#6c757d",
                fontSize: "20px",
              }}
            />
          )}

          {/* Hover Edit Icon Overlay */}
          <div
            className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              opacity: 0,
              transition: "opacity 0.3s ease",
            }}
          >
            <BiSolidEdit size={32} color="white" />
          </div>
        </div>
      </label>

      {/* Hover effect */}
      <style>
        {`
          label:hover div > div:last-child {
            opacity: 1;
          }
          label:hover img, label:hover .ant-avatar {
            filter: brightness(85%);
          }
        `}
      </style>
    </div>
  );
};

export default ImageUpload;
